import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD } from '@wizeoo/akm-core-lib';
import {
  PhysicalTemplateWrapper,
  BasicScenario,
  PhysicalTemplateCriteria,
} from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';


/** find sur modèle de vue (physique) */
export class PhysicalTemplateCmd extends WizCommand<PhysicalTemplateWrapper> {
 
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 
  

  private _basicWrapper: PhysicalTemplateWrapper;
  public getBasicWrapper(): PhysicalTemplateWrapper {
    if (!this._basicWrapper) {
      this._basicWrapper = new PhysicalTemplateWrapper();
      this._basicWrapper.criteria = new PhysicalTemplateCriteria();
      this._basicWrapper.criteria.domain = this.model.domainCode;
      this._basicWrapper.scenario = new BasicScenario();
      this._basicWrapper.method = WIZ_COMMAND_METHOD.FIND;
    }
    return this._basicWrapper;
  }

  public find(): PhysicalTemplateCmd {
    const wrapper: PhysicalTemplateWrapper = this.getBasicWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.PHYSICALTEMPLATE_API, wrapper);
    return this;
  }

  // @Override. Alimentation du modèle sur retour de service
  public wizResult() {
    super.wizResult();
    const resVO = this.model.physicalTemplateEngine.feed(this.result.entities);
  }
}
